import React from 'react'
import AdminUsersContainer from '../../modules/GAAdminUsers/containers/AdminUsersContainer/AdminUsersContainer'

const GAAdminUsers = () => {
  return <AdminUsersContainer />
}

export default GAAdminUsers;